export class BlujayUrl {

  constructor(
    public name?: string,
    public label?: string
  ) {
  }

}
